export var WorkShiftStatus;
(function (WorkShiftStatus) {
    WorkShiftStatus["RUNNING"] = "running";
    WorkShiftStatus["FINISHED"] = "finished";
})(WorkShiftStatus || (WorkShiftStatus = {}));
export var WorkShiftType;
(function (WorkShiftType) {
    WorkShiftType["NORMAL"] = "normal";
    WorkShiftType["PTO"] = "pto";
    WorkShiftType["HOLIDAY"] = "holiday";
    WorkShiftType["SICK_LEAVE"] = "sickleave";
    WorkShiftType["TRAINING"] = "training";
    WorkShiftType["OVERTIME"] = "overtime";
    WorkShiftType["NO_SHOW"] = "noshow";
    WorkShiftType["RAINDAY"] = "rainday";
})(WorkShiftType || (WorkShiftType = {}));
export var WorkShiftLocationType;
(function (WorkShiftLocationType) {
    WorkShiftLocationType["YARD"] = "yard";
    WorkShiftLocationType["SITE"] = "site";
    WorkShiftLocationType["UNKNOWN"] = "unknown";
})(WorkShiftLocationType || (WorkShiftLocationType = {}));
export var WorkShiftPictureMatchStatus;
(function (WorkShiftPictureMatchStatus) {
    WorkShiftPictureMatchStatus["PENDING"] = "pending";
    WorkShiftPictureMatchStatus["MATCHED"] = "matched";
    WorkShiftPictureMatchStatus["NOT_MATCHED"] = "notMatched";
})(WorkShiftPictureMatchStatus || (WorkShiftPictureMatchStatus = {}));
//# sourceMappingURL=workShiftModel.js.map